<!-- Guest Pass Summary (stats only) -->
<div [attr.data-testid]="'guest-pass-summary-container'">
  <!-- Loading Skeleton -->
  @if (loading) {
    <div class="grid text-center p-2">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <div class="col">
          <p-skeleton width="100%" height="2.5rem" styleClass="mb-1" />
          <p-skeleton width="60%" height="1rem" styleClass="mx-auto" />
        </div>
      }
    </div>
  }
  @if (!loading && (summary$ | async); as summary) {
    <div
      class="grid text-center border-1 border-300 border-round overflow-hidden"
      [attr.data-testid]="'guest-pass-stats-grid'"
    >
      <div
        class="col border-right-1 border-300 py-3"
        [attr.data-testid]="'guest-pass-stat-total'"
      >
        <div class="text-xl font-bold text-900">
          {{ summary.service_sessions | number }}
        </div>
        <div class="text-xs text-500 mt-1 uppercase font-medium">
          {{ 'GUEST_PASS.SUMMARY.TOTAL' | translate }}
        </div>
      </div>
      <div
        class="col border-right-1 border-300 py-3"
        [attr.data-testid]="'guest-pass-stat-used'"
      >
        <div class="text-xl font-bold text-green-600">
          {{ summary.service_sessions_used | number }}
        </div>
        <div class="text-xs text-500 mt-1 uppercase font-medium">
          {{ 'GUEST_PASS.SUMMARY.USED' | translate }}
        </div>
      </div>
      <div
        class="col border-right-1 border-300 py-3"
        [attr.data-testid]="'guest-pass-stat-booked'"
      >
        <div class="text-xl font-bold text-blue-600">
          {{ summary.service_sessions_booked | number }}
        </div>
        <div class="text-xs text-500 mt-1 uppercase font-medium">
          {{ 'GUEST_PASS.SUMMARY.BOOKED' | translate }}
        </div>
      </div>
      <div
        class="col border-right-1 border-300 py-3"
        [attr.data-testid]="'guest-pass-stat-noshow'"
      >
        <div class="text-xl font-bold text-red-600">
          {{ summary.service_sessions_noshow | number }}
        </div>
        <div class="text-xs text-500 mt-1 uppercase font-medium">
          {{ 'GUEST_PASS.SUMMARY.NO_SHOW' | translate }}
        </div>
      </div>
      <div
        class="col py-3"
        [attr.data-testid]="'guest-pass-stat-available'"
      >
        <div class="text-xl font-bold text-primary">
          {{ summary.available_sessions | number }}
        </div>
        <div class="text-xs text-500 mt-1 uppercase font-medium">
          {{ 'GUEST_PASS.SUMMARY.AVAILABLE' | translate }}
        </div>
      </div>
    </div>
  }
</div>
<!-- Guest Pass Summary -->
